import gql from 'graphql-tag';

const DELETE_POLL = gql`
    mutation exportReponses($input: ExportResponseInput) {
        exportReponses (input: $input) {
            internalCode
        }
    }
`;

export default DELETE_POLL;
